var App = App || {};

App.Chat = (function () {
    'use strict';

    const CHAT_HASH = "#chat";

    // Resolves with the Zoom Contact Center SDK once it is ready to open; the global exists before it is ready.
    const getSdk = () => new Promise(resolve => {
        if (window.zoomCampaignSdk?.isReady) {
            resolve(window.zoomCampaignSdk);
            return;
        }
        window.addEventListener("zoomCampaignSdk:ready", () => resolve(window.zoomCampaignSdk), { once: true });
    });

    // Opens the chat dialog, closing any open offcanvas (e.g. the mobile menu) first.
    const open = () => {
        document.querySelectorAll(".offcanvas.show").forEach(element => {
            bootstrap.Offcanvas.getInstance(element)?.hide();
        });

        getSdk().then(sdk => sdk.open());
    };

    // Opens the chat when the given href or hash points to #chat on the current page.
    const openFromHref = (href) => {
        if (!href) return false;

        try {
            const url = new URL(href, window.location.href);
            const isCurrentPage = url.origin === window.location.origin
                && url.pathname.toLowerCase() === window.location.pathname.toLowerCase()
                && url.search === window.location.search;
            if (!isCurrentPage || url.hash.toLowerCase() !== CHAT_HASH) return false;
        } catch {
            return false;
        }

        open();
        return true;
    };

    return {
        open,
        openFromHref
    };

})();
